__webpack_require__.p = "./themes/react-prestashop-theme/assets/";